import { useError } from '@client/hooks/useError';
import { useEntitlementsQueries } from '@client/queries/useEntitlementsQueries';
import { useLoading } from '@client/store/loading.store';

export const useEntitlements = () => {
  const { useOperations } = useEntitlementsQueries();
  const { setError: _setError } = useError();

  const { data: rules, isLoading, isFetching, refetch } = useOperations();

  const { loading } = useLoading(isLoading || isFetching);

  return {
    loading,
    rules: rules ?? [],
    total: rules?.length ?? 0,
    refetch,
  };
};
